/*
 * Copyright (c) 2021-2024. StockAnywhere CC
 * StockAnywhere - https://www.stockanywhere.io
 * View license agreement and terms of use at https://www.stockanywhere.io/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2024-06-30
 */

import React from "react";
import { IQueryColumnDetails } from "../Interfaces";
import { color } from "echarts";

export const ListColumns: React.FC<{columnDetails: IQueryColumnDetails[]}> = (props) => {

    let i: number = 0;
    const thStyle: React.CSSProperties = {
        border: '1px solid #deebed',
        color: "#6c757d",
        padding: "8px",
        whiteSpace: "nowrap" as const,
        backgroundColor: "#f8f9fa",
    };



    // change column names for display
    function transformString(inputString:string) {
        // Check if the input is a string
        if (typeof inputString !== 'string') {
            return inputString;
        }

        // Remove underscores and capitalize letters following each underscore
        const result = inputString
          .split('_') // Split the string by underscores
          .map((word, index) => {
            // Capitalize the first letter of each word after the first
            return index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1);
          })
          .join(' '); // Join all the words back together
      
        // Ensure the first letter is capitalized
        return result.charAt(0).toUpperCase() + result.slice(1);
    }

    const columns: React.ReactElement[] = [];

    // Data
    if (Array.isArray(props.columnDetails)) {
        props.columnDetails.forEach((column: IQueryColumnDetails) => {
            const columnName = column.displayColumnName || column.fullColumnName;
            const fullColumnName = column.fullColumnName?.toLowerCase();

            if (!columnName || fullColumnName === 'notifications.reference') return;
            if (!columnName || fullColumnName === 'id') return;

            const displayName = fullColumnName === 'assets.url'
                ? 'Image'
                : transformString(columnName);

            columns.push(
                <th key={i++} scope="col" style={thStyle}>
                    <span className="th-name">{displayName}</span>
                </th>
            );
        });
    }

    return(
        <>
        <thead className="sa-list-columns">
            <tr>                             
                {columns}                 
                <th className="sa-record-control sa-export-selected-records" style={thStyle}>
                    Actions
                </th>                                         
            </tr>
        </thead>
        </>
    );
}